export default "__VITE_ASSET__r97hou72__"